import { fork } from 'redux-saga/effects';

import { loggedStudentSaga } from './userSagas';
import {
  watchActivateReceiveQuestionsNotification,
  watchActivateSubscription,
  watchAnswerSelfPromotion,
  watchApplyCouponUser,
  watchBannersActive,
  watchBuildChapterStudyPlan,
  watchCancelScheduleOnSwitchIosToStripe,
  watchCancelSubscription,
  watchChangeSubscription,
  watchCheckChapterInReview,
  watchCheckCoupon,
  watchCheckDailyQuizStatus,
  watchCheckEmailExists,
  watchCheckQualDailyQuizStatus,
  watchCustomerSiteMockUp,
  watchDeleteCustomPlaylist,
  watchDeleteUserSubmittedQuestion,
  watchDisableQuestion,
  watchEditPaymentDetails,
  watchEditSubmitQuestion,
  watchFavoriteQuestion,
  watchFetchMyReferrals,
  watchFetchPendingSelfPromotions,
  watchGenerateCustomPracticeExam,
  watchGetActivity,
  watchGetAllFavoriteQuestions,
  watchGetAllPublicRates,
  watchGetAllRates,
  watchGetAudioPlaylist,
  watchGetAudioPlaylistProgressSaga,
  watchGetAvailableChapters,
  watchGetAvailableQualForDailyQuiz,
  watchGetBadges,
  watchGetCustomerSiteMockUp,
  watchGetCustomPlaylists,
  watchGetCustomPracticeExamReferences,
  watchGetCustomPracticeExamSettings,
  watchGetCustomSync,
  watchGetDailyQuizHistory,
  watchGetDailyQuizQuestions,
  watchGetDailyQuizResults,
  watchGetDisabledQuestions,
  watchGetEveryoneLeaderboard,
  watchGetFavoriteQuestions,
  watchGetFeaturedBlog,
  watchGetFeaturedForum,
  watchGetFeaturedPodcast,
  watchGetFrieandLeaderboard,
  watchGetFriendActivity,
  watchGetFriendBadges,
  watchGetFriendHeader,
  watchGetFriendProfile,
  watchgetFriendRequestNotifications,
  watchGetFriendScoringHistory,
  watchGetFriendStats,
  watchGetInviteAFriend,
  watchGetLastCouponUser,
  watchGetNotificationMessages,
  watchGetNotificationPreferencesSagas,
  watchGetOneDailyQuizHistory,
  watchGetOneQualDailyQuizHistory,
  watchgetPracticeExamQuestions,
  watchGetQualDailyQuizHistory,
  watchGetQualFromId,
  watchGetQualsData,
  watchGetQuestionsByChapter,
  watchGetQuestionsByPersonalizedStudyAll,
  watchGetQuestionsByQuals,
  watchGetQuestionsByRate,
  watchGetRecomendedTopics,
  watchGetReferencesData,
  watchGetScoringHistory,
  watchGetStats,
  watchGetSubmittedQuestions,
  watchGetUserSubmittedQuestions,
  watchGetWeeklyPracticeExams,
  watchLoadChapterStudyPlan,
  watchLoadDailyQuiz,
  watchLoadDashboardHeaderInfo,
  watchLoadFeaturedBlog,
  watchLoadFriends,
  watchLoadPlans,
  watchLoadPointsThisWeekSaga,
  watchLoadPossibleCyclesForUpdateExam,
  watchLoadPossibleCyclesForUser,
  watchLoadPostCategories,
  watchLoadQualDailyQuiz,
  watchLoadResourcesPosts,
  watchLoadSktData,
  watchLoadUserSubscription,
  watchMakeSubscription,
  watchPdfByReference,
  watchPostExamChecklistPdf,
  watchPracticeExamResults,
  watchRemoveAllFavoriteQuestions,
  watchRemoveFavoriteQuestions,
  watchRemoveFriend,
  watchRenewSubscription,
  watchReportQuestion,
  watchResetAllDisabledQuestions,
  watchResetChapter,
  watchResetDisabledIndividualQuestion,
  watchresetPasswordSagas,
  watchResolveFriendRequest,
  watchRevertCancellation,
  watchSaveSelectedChapters,
  watchSendAnswer,
  watchSendDailyQuizAnswer,
  watchSendFriendsRequest,
  watchSendNotificationPreferencesSagas,
  watchSendReferral,
  watchSetNotificationMessagesSeen,
  watchSetStudySpeedSettings,
  watchSetUserCycle,
  watchStartPracticeExam,
  watchStudyByFavoriteQuestions,
  watchStudyByMyFavoriteQuestions,
  watchStudyByMySubmittedQuestions,
  watchStudyBySubmittedQuestions,
  watchStudyContentByRef,
  watchStudyContentByStudyAll,
  watchStudyContentByWarfareQuals,
  watchSubmitDailyQuiz,
  watchSubmitNewQuestion,
  watchSubmitPracticeExamResults,
  watchSubmitQualDailyQuiz,
  watchswitchSubscriptionToStripe,
  watchUpdateAudioPlaylistProgressSaga,
  watchUpdateCustomSync,
  watchUpdateDailyQuiz,
  watchUpdateDisabledChapter,
  watchUpdateEmail,
  watchUpdateFlashCardOnly,
  watchUpdatePassword,
  watchUpdatePersonalData,
  watchUpdatePracticeExamResults,
  watchUpdateProfilePrivacy,
  watchUpdateQualDailyQuiz,
  watchUpdateRatingExam,
  watchUpdateSubscriptionPlan,
  watchUpdateSwitchPfeSkt,
  watchUpdateTimezone,
  watchUpdateUserAnswers,
  watchUpdateUsername,
  watchUpdateUserSettingQualForDailyQuizSaga,
  watchUpgradeSubscription,
  watchUploadProfileImage,
  watchUserAuthentication,
  watchUserLogout,
  watchUserProgressOnChaptersSaga,
  watchUserRequestPassword,
  watchVerifyIsMaintenanceSaga,
} from './watchers';

export default function* startForman() {
  yield fork(loggedStudentSaga);
  yield fork(watchGetFriendHeader);
  yield fork(watchGetFriendProfile);
  yield fork(watchGetFriendScoringHistory);
  yield fork(watchGetFriendBadges);
  yield fork(watchGetFriendStats);
  yield fork(watchGetFriendActivity);
  yield fork(watchUserAuthentication);
  yield fork(watchUserLogout);
  yield fork(watchGetQuestionsByPersonalizedStudyAll);
  yield fork(watchStudyContentByRef);
  yield fork(watchLoadSktData);
  yield fork(watchStudyByFavoriteQuestions);
  yield fork(watchStudyByMyFavoriteQuestions);
  yield fork(watchStudyContentByWarfareQuals);
  yield fork(watchGetQualFromId);
  yield fork(watchPdfByReference);
  yield fork(watchPostExamChecklistPdf);
  yield fork(watchApplyCouponUser);
  yield fork(watchGetLastCouponUser);
  yield fork(watchStudyContentByStudyAll);
  yield fork(watchGetQuestionsByRate);
  yield fork(watchGetQuestionsByQuals);
  yield fork(watchGetQuestionsByChapter);
  yield fork(watchSendAnswer);
  yield fork(watchFavoriteQuestion);
  yield fork(watchResetChapter);
  yield fork(watchUpdateUserAnswers);
  yield fork(watchCheckChapterInReview);
  yield fork(watchUserRequestPassword);
  yield fork(watchresetPasswordSagas);
  yield fork(watchGetDailyQuizQuestions);
  yield fork(watchSendDailyQuizAnswer);
  yield fork(watchGetDailyQuizResults);
  yield fork(watchGetStats);
  yield fork(watchLoadPointsThisWeekSaga);
  yield fork(watchGetActivity);
  yield fork(watchGetFrieandLeaderboard);
  yield fork(watchGetEveryoneLeaderboard);
  yield fork(watchGetScoringHistory);
  yield fork(watchGetBadges);
  yield fork(watchGetDailyQuizHistory);
  yield fork(watchGetQualDailyQuizHistory);
  yield fork(watchGetOneDailyQuizHistory);
  yield fork(watchGetOneQualDailyQuizHistory);
  yield fork(watchGetRecomendedTopics);
  yield fork(watchSendNotificationPreferencesSagas);
  yield fork(watchGetNotificationPreferencesSagas);
  yield fork(watchGetFeaturedBlog);
  yield fork(watchGetFeaturedForum);
  yield fork(watchGetFeaturedPodcast);
  yield fork(watchGetInviteAFriend);
  yield fork(watchUpdateProfilePrivacy);
  yield fork(watchUpdateFlashCardOnly);
  yield fork(watchUpdateSwitchPfeSkt);
  yield fork(watchUpdateTimezone);
  yield fork(watchUpdateEmail);
  yield fork(watchUpdatePassword);
  yield fork(watchUpdateRatingExam);
  yield fork(watchUpdateUsername);
  yield fork(watchBannersActive);
  yield fork(watchCustomerSiteMockUp);
  yield fork(watchGetCustomerSiteMockUp);
  yield fork(watchGetNotificationMessages);
  yield fork(watchSetNotificationMessagesSeen);
  yield fork(watchUpdatePersonalData);
  yield fork(watchGetAllRates);
  yield fork(watchUploadProfileImage);
  yield fork(watchDisableQuestion);
  yield fork(watchLoadPossibleCyclesForUser);
  yield fork(watchLoadPossibleCyclesForUpdateExam);
  yield fork(watchReportQuestion);
  yield fork(watchResetAllDisabledQuestions);
  yield fork(watchRemoveAllFavoriteQuestions);
  yield fork(watchResetDisabledIndividualQuestion);
  yield fork(watchGetDisabledQuestions);
  yield fork(watchGetFavoriteQuestions);
  yield fork(watchGetAllFavoriteQuestions);
  yield fork(watchRemoveFavoriteQuestions);
  yield fork(watchGetAllPublicRates);
  yield fork(watchGetReferencesData);
  yield fork(watchGetQualsData);
  yield fork(watchLoadPlans);
  yield fork(watchCheckEmailExists);
  yield fork(watchCheckCoupon);
  yield fork(watchMakeSubscription);
  yield fork(watchLoadUserSubscription);
  yield fork(watchEditPaymentDetails);
  yield fork(watchSendFriendsRequest);
  yield fork(watchLoadFriends);
  yield fork(watchRemoveFriend);
  yield fork(watchGetWeeklyPracticeExams);
  yield fork(watchStartPracticeExam);
  yield fork(watchUpdatePracticeExamResults);
  yield fork(watchSubmitPracticeExamResults);
  yield fork(watchPracticeExamResults);
  yield fork(watchUserProgressOnChaptersSaga);
  yield fork(watchgetFriendRequestNotifications);
  yield fork(watchResolveFriendRequest);
  yield fork(watchCancelSubscription);
  yield fork(watchRevertCancellation);
  yield fork(watchswitchSubscriptionToStripe);
  yield fork(watchRenewSubscription);
  yield fork(watchChangeSubscription);
  yield fork(watchUpgradeSubscription);
  yield fork(watchActivateSubscription);
  yield fork(watchUpdateSubscriptionPlan);
  yield fork(watchCheckDailyQuizStatus);
  yield fork(watchCheckQualDailyQuizStatus);
  yield fork(watchLoadDailyQuiz);
  yield fork(watchLoadQualDailyQuiz);
  yield fork(watchUpdateDailyQuiz);
  yield fork(watchUpdateQualDailyQuiz);
  yield fork(watchSubmitDailyQuiz);
  yield fork(watchSubmitQualDailyQuiz);
  yield fork(watchLoadDashboardHeaderInfo);
  yield fork(watchLoadResourcesPosts);
  yield fork(watchLoadPostCategories);
  yield fork(watchLoadFeaturedBlog);
  yield fork(watchActivateReceiveQuestionsNotification);
  yield fork(watchSetUserCycle);
  yield fork(watchSubmitNewQuestion);
  yield fork(watchGetSubmittedQuestions);
  yield fork(watchStudyBySubmittedQuestions);
  yield fork(watchStudyByMySubmittedQuestions);
  yield fork(watchGetUserSubmittedQuestions);
  yield fork(watchDeleteUserSubmittedQuestion);
  yield fork(watchEditSubmitQuestion);
  yield fork(watchSetStudySpeedSettings);
  yield fork(watchGetAvailableQualForDailyQuiz);
  yield fork(watchUpdateUserSettingQualForDailyQuizSaga);
  yield fork(watchVerifyIsMaintenanceSaga);
  yield fork(watchgetPracticeExamQuestions);
  yield fork(watchUpdateDisabledChapter);
  yield fork(watchGetAudioPlaylist);
  yield fork(watchGetAudioPlaylistProgressSaga);
  yield fork(watchUpdateAudioPlaylistProgressSaga);
  yield fork(watchFetchMyReferrals);
  yield fork(watchSendReferral);
  yield fork(watchCancelScheduleOnSwitchIosToStripe);
  yield fork(watchGetCustomPlaylists);
  yield fork(watchDeleteCustomPlaylist);
  yield fork(watchGetAvailableChapters);
  yield fork(watchSaveSelectedChapters);
  yield fork(watchBuildChapterStudyPlan);
  yield fork(watchLoadChapterStudyPlan);
  yield fork(watchGenerateCustomPracticeExam);
  yield fork(watchGetCustomPracticeExamReferences);
  yield fork(watchGetCustomPracticeExamSettings);
  yield fork(watchFetchPendingSelfPromotions);
  yield fork(watchAnswerSelfPromotion);
  yield fork(watchGetCustomSync);
  yield fork(watchUpdateCustomSync);
}
